import { logEvent } from '@/etc/firebase';

interface PathHistoryParams {
  screenName: string;
}

interface EventHistoryParams {
  eventName: string;
  eventValue?: string;
  deviceUuid?: string;
}

export const useLog = (sellerId: string) => {
  const setUserPathHistory = ({ screenName }: PathHistoryParams) => {
    if (!sellerId) return;
    logEvent('page_view', {
      page_path: screenName,
      page_title: document.title,
    });
  };
  const setUserEventHistory = ({ eventName, eventValue = '' }: EventHistoryParams) => {
    if (!sellerId) return;
    logEvent(eventName, {
      event_value: eventValue,
    });
  };
  return { setUserPathHistory, setUserEventHistory };
};
